import React from "react";
import HeartRate from '../components/moreComponents/HeartRate'
import CooperTest from '../components/moreComponents/CooperTest'
import {
  Card,
  CardHeader,
  CardFooter,
  Row,
  Col,
  Button,
  Input,
} from "reactstrap";

import StopWatch from '../assets/img/stopwatch.png'



const buttonStyle = {
    width: '70px',
    height: '30px',
    padding: '6px 0px',
    borderRadius: '5px',
    fontSize: '12px',
    lineHeight: '1.42857',
    marginTop:'10px'
    
}
class Tools extends React.Component {
  
    
  
  render() {
    
    //console.log(this.props.auth.strava_connected)
    
    //const loca  = localStorage.getItem('user')
    

    return (
      <>
        <div className="content" style={{marginTop:'40px'}}>
          <h4 style={{color:'rgb(240,240,240)'}}>Tools/Calculators</h4>
          <p className="category"></p>
            <Card style={{backgroundColor:'rgb(30,30,30)',marginTop:'30px'}}>
              
                <CardHeader>
                <h3 style={{color:'rgb(200,200,200'}}>Heart rate monitor</h3>
                    <Row>
                        
                        <Col lg={6} sm={6} md={6}>
                            <HeartRate/>
                        </Col>
                        
                    </Row>
                </CardHeader>
                <CardFooter>
                    <div>

                    </div>
                </CardFooter>
            </Card>
            <Card style={{backgroundColor:'rgb(30,30,30)',marginTop:'30px'}}>
            
                <CardHeader>
                  <h3 style={{color:'rgb(200,200,200'}}>Cooper test</h3>
                    <Row>
                        
                        <Col lg={6} sm={6} md={6}>
                            <CooperTest/>
                        </Col>
                        
                    </Row>
                </CardHeader>
                <CardFooter>
                    <div>

                    </div>
                </CardFooter>
            </Card>

    
        </div>
      </>
    );
  }
}



export default Tools;
